module.exports = __webpack_public_path__ + "img/vennDiagram.478f5f56.png";